import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import categories from './slices/categoriesSlice'
import links from './slices/linksSlice'
import explore from './slices/exploreSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        categories,
        links,
        explore,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
